import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scrolls window to top whenever the route changes.
 *  Skips scroll if the URL has a hash (so anchor links still work). */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}
